import { createSlice } from '@reduxjs/toolkit';
import { asyncIsFulfilled, asyncIsPending, asyncIsRejected } from '../asyncConfig';
import { addPaymentMethod, getAllPaymentMenthods, getMethodFulfilled, updatePaymentMethodById } from './payment_methods_thunk';

const initialState = {
  payment_methods: [],
  status: '',
  message: ''
}

export const methodsSlice = createSlice({
  name: 'payment-methods',
  initialState,
  extraReducers: {
    [getAllPaymentMenthods.pending]: asyncIsPending,
    [getAllPaymentMenthods.rejected]: asyncIsRejected,
    [getAllPaymentMenthods.fulfilled]: getMethodFulfilled,
    [addPaymentMethod.pending]: asyncIsPending,
    [addPaymentMethod.rejected]: asyncIsRejected,
    [addPaymentMethod.fulfilled]: asyncIsFulfilled,
    [updatePaymentMethodById.pending]: asyncIsPending,
    [updatePaymentMethodById.rejected]: asyncIsRejected,
    [updatePaymentMethodById.fulfilled]: asyncIsFulfilled,
  }
});

export default methodsSlice.reducer;